import { CSSObject } from '@emotion/react'

/* Styling for div surrounding retweet */
const getRetweetWrapper = (isStream: boolean): CSSObject => ({
  margin: isStream ? '0 16px 0 75px' : '0 16px 0 16px',
})

const sharedStyles = {
  getRetweetWrapper,
}

export { sharedStyles }
